/**
 * Server timestamps. SQLite `datetime('now')` stores UTC without a zone
 * (`YYYY-MM-DD HH:MM:SS`); `new Date()` would read that as local time.
 * Values with a zone (ISO 8601 or Postgres) are read as given.
 */

const ZONELESS_TIMESTAMP = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;

export function parseServerTimestamp(value: string): Date | null {
  const trimmed = value.trim();
  const zoneless = ZONELESS_TIMESTAMP.exec(trimmed);
  const date = new Date(zoneless ? `${zoneless[1]}T${zoneless[2]}Z` : trimmed);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isValidTimeZone(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone });
    return true;
  } catch {
    return false;
  }
}

/** Formats a server timestamp in the user time zone; '' when the value does not parse. */
export function formatServerTimestamp(
  value: string,
  timeZone: string,
  options: Intl.DateTimeFormatOptions,
  locale?: string
): string {
  const date = parseServerTimestamp(value);
  if (!date) return '';
  return new Intl.DateTimeFormat(locale, { ...options, timeZone }).format(date);
}
